import React from "react";
import MyProfile from "../components/account/myProfile";
import Navbar from "../components/common/navbar";
import Footer from "../components/common/footer";
import MobileSidebarLink from "../components/account/mobileSidebarLink";

const AccountPage = () => {
  return (
    <div>
      <Navbar />
      <div className="md:mx-16 flex">
        <div className="hidden md:block">
          <MobileSidebarLink />
        </div>
        <MyProfile />
      </div>
      <Footer />
    </div>
  );
};

export default AccountPage;
